import { render } from "./Docs.vue?vue&type=template&id=0e799892&scoped=true"
import script from "./Docs.vue?vue&type=script&lang=js"
export * from "./Docs.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0e799892"

export default script